import AppDialog from "@/components/AppDialog";
import SiteLayout from "@/components/layouts/SiteLayout";
import FacebookAuthService from "@/server/services/auth/FacebookAuthService";
import UserService from "@/server/services/user/UserService";
import CommonUtils from "@/utils/CommonUtils";
import axios from "axios";
import { useRouter } from "next/router";
import { useState } from "react";
import { FaGoogle } from "react-icons/fa";
import { LuInstagram } from "react-icons/lu";

export async function getServerSideProps(context) {
  const loginLink = FacebookAuthService.getInstagramLoginURL();

  console.log("loginLink", loginLink);

  try {
    const user = await UserService.getLoggedInUser(context.req, {
      whatsapp_number: true,
      phone: true,
      thumbnail_path: true,
    });
    if (user) {
      return {
        redirect: {
          destination: `/${CommonUtils.getLocaleFromContext(
            context
          )}agent-admin/account/business-profile`,
          permanent: false,
        },
      };
    }
  } catch (ignore) {}

  return { props: { loginLink } };
}

export default function SignIn({ loginLink }) {
  //check if there is error parameter in the url
  const [clickDisabled, setClickDisabled] = useState(false);
  const [signInWithUsernameAndPassword, setSignInWithUsernameAndPassword] =
    useState(false);
  const [isLoginInWithCredentials, setIsLoginInWithCredentials] =
    useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [instaClickDisabled, setInstagramClickDisabled] = useState(false);
  const router = useRouter();
  const error = router.query.error;
  let error_message = "";

  switch (error) {
    case "token":
      error_message = "Could not complete login, please try again";
      break;
    case "not-finished":
      error_message = "Login process was not completed, please try again";
      break;
    case "account":
      error_message = "Could not retrieve account details, please try again";
      break;
    case "permissions":
      error_message =
        "Can't access your Instagram. Check you have a business account and granted all permissions.";
      break;
    default:
      error_message = "";
      break;
  }

  const connect = () => {
    setInstagramClickDisabled(true);
    window.location.href = loginLink;
  };
  const signInWithGoogle = () => {
    setClickDisabled(true);
    router.push("/api/google-auth");
  };

  const signInWithCredentials = async () => {
    setErrorMessage("");
    if (username == "" || password == "") {
      setErrorMessage("Please fill in all fields");
      return;
    }

    setIsLoginInWithCredentials(true);

    let body = {
      username: username,
      password: password,
    };

    const url = "/api/auth/sign-in-with-credentials";
    try {
      const response = await axios.post(url, body);
      if (response.data.success) {
        window.location.href = "/agent-admin/listings";
      }
    } catch (error) {
      console.log("Error signing in", error);
      setIsLoginInWithCredentials(false);
      setErrorMessage(error.response.data.error);
    }
  };

  return (
    <SiteLayout
      title={"Login or Register as agent | " + CommonUtils.appName}
      description="
        Login or Register as agent to start listing your properties on Makazi Mapya
      "
    >
      {signInWithUsernameAndPassword && (
        <AppDialog
          type="custom"
          title="Sign in with username and password"
          onClose={() => {
            setSignInWithUsernameAndPassword(false);
          }}
          children={
            <div>
              <div className="text-gray-800 text-lg font-bold">
                Sign in with username and password
              </div>
              <div className="mt-4">
                <input
                  type="text"
                  placeholder="Username"
                  onChange={(e) => {
                    setUsername(e.target.value);
                  }}
                  className="border border-gray-300 p-2 w-full"
                />

                <div className="mt-4 relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                    className="border border-gray-300 p-2 w-full"
                  />
                  <div
                    onClick={() => {
                      setShowPassword(!showPassword);
                    }}
                    className="absolute right-4 top-4 cursor-pointer"
                  >
                    {showPassword ? "Hide" : "Show"}
                  </div>
                </div>

                {errorMessage && (
                  <div className="text-red-500 mt-2">{errorMessage}</div>
                )}

                <div className="flex justify-end mt-4">
                  <button
                    onClick={() => {
                      setSignInWithUsernameAndPassword(false);
                    }}
                    className="bg-gray-200 text-gray-800 p-2 px-4 rounded mt-4 mr-4"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={() => {
                      signInWithCredentials();
                    }}
                    className="bg-blue-500 text-white p-2 px-4 rounded mt-4"
                  >
                    Sign in
                  </button>
                </div>
              </div>
            </div>
          }
        />
      )}
      {isLoginInWithCredentials && (
        <AppDialog type="loader" title="Signin you in" text="Please wait..." />
      )}
      <div className="container mx-auto space-y-4  text-center mb-[400px] mt-[200px]">
        {error_message && (
          <div
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
            role="alert"
          >
            <div className="font-bold">Error!</div>
            <span className="block sm:inline">{error_message}</span>
          </div>
        )}

        <h2 className="text-3xl">Sign in as agent</h2>

        <div className="mt-10 grid place-content-center gap-4">
          <div>
            <button
              disabled={instaClickDisabled}
              onClick={connect}
              className="bg-blue-500 w-full justify-center text-center text-white px-4 py-3 space-x-2 rounded font-bold text-lg flex items-center"
            >
              <LuInstagram className="inline-block " />
              <span>
                {instaClickDisabled ? "Loading..." : "Sign in with Instagram"}
              </span>
            </button>
            <p className="text-gray-600">
              Sign in as agent using your instagram account to sync your posts
            </p>
          </div>

          <div>
            <button
              disabled={clickDisabled}
              onClick={signInWithGoogle}
              className="bg-blue-500 w-full justify-center text-center text-white px-4 py-3 space-x-2 rounded font-bold text-lg flex items-center"
            >
              <FaGoogle className="inline-block " />
              <span>
                {clickDisabled ? "Loading..." : "Sign in with Google"}
              </span>
            </button>
          </div>
          {/*
          <div className="text-gray-500">- OR -</div>
         <div>
            <button
              onClick={() => {
                setSignInWithUsernameAndPassword(true);
              }}
              className="border border-gray-500 w-full justify-center text-center text-gray-500 px-4 py-3 space-x-2 rounded  text-sm flex items-center"
            >
              Sign in with your username and password
            </button>
          </div> */}
          <p className="text-gray-800 mt-4">
            By signing in, you agree to our terms of service and privacy policy
          </p>
        </div>
      </div>
    </SiteLayout>
  );
}
